// extracted by mini-css-extract-plugin
module.exports = {"stack":"styles-module--stack--2qcS7","stack__item":"styles-module--stack__item--1Jpsj"};